import { Injectable } from '@angular/core';
import { CustomFont, CustomFonts } from './custom.font';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '../http/http.service';
import { ApiEndpointService } from '../services/api-endpoint.service';

@Injectable()
export class CustomFontsApi {
  constructor(private httpService: HttpService,
              private apiEndpointService: ApiEndpointService) {
  }

  getCustomFonts(): Observable<CustomFonts> {
    return this.httpService.get(`${ this.apiEndpointService.CustomFonts }`)
      .pipe(map(data => {
        const customFonts = new CustomFonts();
        customFonts.fonts = data.map(font => {
          return Object.assign(new CustomFont(), font);
        });
        return customFonts;
      }));
  }

  deleteCustomFont(ids: string[]): Observable<any> {
    return this.httpService.delete(`${ this.apiEndpointService.CustomFonts }`, ids, true);
  }

  addCustomFont(fontModel: CustomFont): Observable<any> {
    return this.httpService.post(fontModel, `${ this.apiEndpointService.CustomFonts }`, null, true);
  }
}
